/**
 * ==========================================================================
 * NUPEP Frontend Framework
 * --------------------------------------------------------------------------
 * File:        nupep-core.js
 * Version:     3.0.0
 * Author:      NUPEP Development Framework
 * Compatible:  Shopify Online Store 2.0 (Dawn 15+)
 *
 * Description:
 * Core application bootstrap for the NUPEP storefront framework.
 *
 * Responsibilities:
 *  - Framework initialization
 *  - Module registration
 *  - Module lifecycle
 *  - Shopify Theme Editor integration
 *  - Scoped module APIs
 *  - Cleanup management
 *
 * ==========================================================================
 */

(function (window, document) {
  'use strict';

  /* ==========================================================================
     Prevent Multiple Initializations
     ========================================================================== */

  if (window.NUPEP) {
    console.warn('[NUPEP] Framework already initialized.');
    return;
  }

  /* ==========================================================================
     Private State
     ========================================================================== */

  const registry = new Map();

  const cleanupRegistry = new WeakMap();

  const initializedRegistry = new WeakMap();

  /* ==========================================================================
     Framework Configuration
     ========================================================================== */

  const config = Object.freeze({

    version: '3.0.0',

    debug: false,

    breakpoint: 990,

    animationDuration: 300,

    observerThreshold: 0.2,

    colors: {

      gold: '#D4AF37',

      goldDark: '#B89220',

      black: '#1B1B1B',

      white: '#FFFFFF'

    }

  });

  /* ==========================================================================
     Logging
     ========================================================================== */

  function log(...message) {

    if (!config.debug) return;

    console.log('[NUPEP]', ...message);

  }

  function warn(...message) {

    console.warn('[NUPEP]', ...message);

  }

  function error(...message) {

    console.error('[NUPEP]', ...message);

  }

  /* ==========================================================================
     Module Registration
     ========================================================================== */

  function module(definition) {

    if (typeof definition !== 'object') {

      throw new TypeError(
        'NUPEP.module() expects an object.'
      );

    }

    const {

      name,

      selector,

      init,

      destroy

    } = definition;

    if (!name) {

      throw new Error(
        'Every NUPEP module requires a name.'
      );

    }

    if (!selector) {

      throw new Error(
        `"${name}" requires a selector.`
      );

    }

    if (typeof init !== 'function') {

      throw new Error(
        `"${name}" requires an init() function.`
      );

    }

    registry.set(name, {

      name,

      selector,

      init,

      destroy: typeof destroy === 'function'
        ? destroy
        : () => {}

    });

    log(`Module registered → ${name}`);

  }

  /* ==========================================================================
     Public Framework Object
     ========================================================================== */

  window.NUPEP = {

    version: config.version,

    config,

    module,

    modules: registry,

    log,

    warn,

    error

  };

})(window, document);